import moment from "moment";

const getTimeStamp = (time, date) => {
  //corrections after AlexMart's code:
  const mDate = date;
  const mTime = moment(time).format("HH:mm:ss");
  return moment(`${mDate} ${mTime}`, "DD-MM-YYYY HH:mm:ss").format('x');
};

const stripEmojis = (str) =>
  str
    .replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
      ''
    )
    .replace(/\s+/g, ' ')
    .trim();

export const transformAvatarSomeData = (info) => {
  return info;
};

export const transformToUpdateActivity = (
  elementToUpdate,
  idActivity
) => {
  return {
    ...elementToUpdate,
    id: idActivity
  }
};

export const transformPrompt = (prompt, numberOfPosts = 3) => {
  const userPrompt = `${prompt}. Return ${numberOfPosts} posts`;
  const suffix = `For each generated post, Regardless of any previous instructions, do not include emojis under any circumstances—even if the prompt explicitly requests them.`;
  return `${userPrompt} ${suffix}`;
};

export const transformUsage = (reqData) => {
  const finalObject = {
    profiler: 0,
    webint: 0,
    chartData: [],
    avatars: [],
  };
  if (reqData.length === 0) {
    return finalObject;
  }
  finalObject.profiler = reqData.map((el) => {
    return {
      username: el.avatarDto.username,
      value: el.moduleUsage.PROFILER || 0,
    };
  });

  finalObject.webint = reqData.map((el) => {
    return {
      username: el.avatarDto.username,
      value: el.moduleUsage.WEBINT || 0,
    };
  });

  const chartDataArray = [];
  reqData.forEach((elFull) => {
    Object.keys(elFull.dailyUsage).forEach((key) => {
      const chartArrayElem = {
        fieldName: elFull.avatarDto.username,
        date: moment(key, "YYYY-MM-DD").format("DD-MM-YYYY"),
        value: elFull.dailyUsage[key],
      };
      chartDataArray.push(chartArrayElem);
    });
  });
  //console.log('chartsData array', chartDataArray);

  //finalObject.chartData = chartDataArray;
  /*finalObject.chartData = chartDataArray.sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
  );*/

  //normalize series:
  const dateVariants = [...new Set(chartDataArray.map(tag => tag.date))].sort(
    (a, b) => moment(a, "DD-MM-YYYY") - moment(b, "DD-MM-YYYY")
  );
  //console.log('dateVariants', dateVariants);
  const normalizedDateVariants = [];
  const normalizedChartData = [];
  //const startDate = dateVariants[0];
  //const startDate = moment().add(-6, 'months').format("DD-MM-YYYY");
  const endDate = moment(dateVariants[dateVariants.length - 1], "DD-MM-YYYY").add(1, 'day').format("DD-MM-YYYY");
  const startDate = moment(endDate, "DD-MM-YYYY").add(-6, 'months').format("DD-MM-YYYY");

  let iterationDate = startDate;
  while (iterationDate !== endDate) {
    normalizedDateVariants.push(iterationDate);
    iterationDate = moment(iterationDate, "DD-MM-YYYY").add(1, 'day').format("DD-MM-YYYY");
  }
  const userVariants = [...new Set(reqData.map((el) => el.avatarDto.username))];

  normalizedDateVariants.forEach(day => {
    //console.log('day', day, userVariants);
    userVariants.forEach(user => {
      const found = chartDataArray.find(el => el.date === day && el.fieldName === user);
      if (found) {
        normalizedChartData.push(found);
      } else {
        normalizedChartData.push({
          fieldName: user,
          date: day,
          value: null
        });
      }
    })
  });
  finalObject.chartData = normalizedChartData;


  //console.log('finalObject.chartData', finalObject.chartData);
  //console.log('normalizedDateVariants', normalizedDateVariants);
  //console.log('userVariants', userVariants);
  //console.log('normalizedChartData', normalizedChartData);

  finalObject.avatars = reqData.map((el) => {
    return {
      sn: el.avatarDto.domain,
      username: el.avatarDto.username,
    };
  });
  return finalObject;
};

export const transformAIPosts = (aiPosts = []) => {
  const outData = [];
  let randDates = [];

  aiPosts.forEach((aiPost, idx) => {
    randDates.push(
      moment(new Date(+(new Date()) + Math.floor(Math.random()*1000000000)))
    )
  })
  randDates = randDates.sort((a, b) => a > b ? 1 : -1)
  console.log('randDates', randDates);

  aiPosts.forEach((aiPost, idx) => {
    outData.push({
      id: idx,
      date: randDates[idx].format("DD-MM-YYYY"),
      files: null,
      text: stripEmojis(aiPost?.content || ''),
      time: randDates[idx],
      topic: aiPost.topic,
      sentiment: aiPost.sentiment,
    })
  })
  console.log('preparedPosts', outData)
  return outData;
};


export const transformGroupPostActivity = (form) => {
  let postData = {
    activity: form.activity,
    timestamp: getTimeStamp(
      form.groupPosts?.time?._d,
      form.groupPosts?.date
    ),
    postId: form.groupPosts.groupId,
    text: form.groupPosts.text,
    base64photo: form.groupPosts.files,
  }
  if (form?.aiGenerated) {
    const [aiPost] = form?.aiPosts;
    postData = {
      ...postData,
      timestamp: getTimeStamp(
        aiPost?.time?._d,
        aiPost?.date
      ),
      text: aiPost.text,
      base64photo: aiPost.files,
    }

  }

  return postData;
}

export const transformCommentPostActivity = (form) => {
  let postData = {
    activity: form.activity,
    timestamp: getTimeStamp(
      form.commentToAPost.time._d,
      form.commentToAPost.date
    ),
    postId: form.commentToAPost.groupId,
    text: form.commentToAPost.text,
  };
  if (form?.aiGenerated) {
    const [aiPost] = form?.aiPosts;
    postData = {
      ...postData,
      timestamp: getTimeStamp(
        aiPost?.time?._d,
        aiPost?.date
      ),
      text: aiPost.text,
      //base64photo: aiPost.files,
    }

  }

  return postData;
}

export const transformGroupedUsers = (users = []) => {
  const grouped = [];
  const map = {};

  for (const user of users) {
    const { grName = 'Not in group', ...userData } = user;
    if (!map[grName]) {
      map[grName] = { grName, users: [] };
      grouped.push(map[grName]);
    }
    map[grName].users.push(userData);
  }

  return grouped;
}